import React, {Component} from 'react';
import { IMAGE_URL} from "./../../config/Config";
import {Col, Mask, View} from "mdbreact";
import {Link} from "react-router-dom";


export default class MyComponent extends Component {

    render() {
        const {cover,logo,name,id } = this.props;
        return (
            <Col md="3" xs="12">
                <View zoom className="most-pop-item">
                    <img src={IMAGE_URL + cover} className="img-fluid w-100 cover" alt={name} />
                    <Mask className="flex-center" >
                        <div className="text-center w100 m-1">
                            <p className="text-center logo" style={{width:50, height:50}}>
                                <img src={IMAGE_URL + logo} className="logo" alt={name} />
                            </p>
                            <br/>
                            <h4 className=" title">{name}</h4>
                            <br/>
                            <Link to={`/merchant/${id}`} className="btn btn-deep-orange">مشاهده</Link>
                        </div>
                    </Mask>
                </View>
            </Col>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/merchants/MostPopularMerchant.js